module.exports = __webpack_public_path__ + "static/img/zhengShu11.464412f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhengShu11.jpg
// module id = V7zY
// module chunks = 2